/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Standings_PrivateInputs */



/**
* | output |
* | --- |
* | "Private" |
*
* @param {Tournament_Standings_PrivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_standings_private = /** @type {((inputs?: Tournament_Standings_PrivateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Standings_PrivateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Privé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Privado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Privado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Privato")
	return /** @type {LocalizedString} */ ("Private")
});